import { useAuth, useAngelaPage } from "@/App";
import { Sparkles, Hash, Menu } from "lucide-react";
import { useLocation } from "react-router-dom";
import NotificationBell from "@/components/layout/NotificationBell";
import { TrainingButton } from "@/components/training";
import { useEntitlements } from "@/hooks/useEntitlements";

export default function Header({ onAngelaClick, onMenuClick }) {
  const { user } = useAuth();
  const { page, projectData } = useAngelaPage();
  const location = useLocation();
  const { trainingEnabled } = useEntitlements();

  const isOnProject = page === "project" && projectData;

  return (
    <header className="h-14 md:h-16 border-b border-white/[0.04] bg-[#080c10]/80 backdrop-blur-sm flex items-center justify-between px-3 sm:px-4 md:px-6 gap-2 md:gap-4" data-testid="header">
      {/* Left: Hamburger + Project context */}
      <div className="flex items-center gap-2 md:gap-3 min-w-0 flex-1">
        {/* Mobile hamburger */}
        <button
          onClick={onMenuClick}
          data-testid="mobile-menu-btn"
          className="md:hidden p-2 rounded-lg text-slate-400 hover:text-white hover:bg-white/[0.06] transition-colors flex-shrink-0"
        >
          <Menu className="w-5 h-5" />
        </button>

        {isOnProject && (
          <>
            {projectData.record_number && (
              <span className="hidden sm:inline-flex items-center gap-1 px-2 py-0.5 rounded bg-[#2A9D9D]/15 text-[#2A9D9D] text-[10px] font-mono font-bold flex-shrink-0">
                <Hash className="w-3 h-3" />{projectData.record_number}
              </span>
            )}
            <h1 className="text-sm md:text-base font-heading font-bold text-white uppercase tracking-tight truncate" data-testid="header-project-title">
              {projectData.title}
            </h1>
          </>
        )}
      </div>

      {/* Right: Actions */}
      <div className="flex items-center gap-2 md:gap-3 flex-shrink-0">
        {/* Training Button */}
        {trainingEnabled && <TrainingButton className="hidden sm:flex" />}

        {/* Ask Angela Button */}
        <button
          onClick={onAngelaClick}
          data-testid="header-angela-btn"
          className="flex items-center gap-1.5 md:gap-2 px-2.5 md:px-4 py-1.5 md:py-2 rounded-xl bg-[#2A9D9D]/10 text-[#2A9D9D] font-semibold transition-all duration-300 hover:bg-[#2A9D9D]/20 hover:shadow-[0_0_20px_rgba(0,212,255,0.2)]"
        >
          <Sparkles className="w-4 h-4" />
          <span className="hidden sm:inline text-sm md:text-base">Ask Angela</span>
        </button>

        {/* Notification Bell */}
        <NotificationBell />
      </div>
    </header>
  );
}
